import { render, staticRenderFns } from "./TrainingCommentsForm.vue?vue&type=template&id=26982ae0&"
import script from "./TrainingCommentsForm.vue?vue&type=script&lang=js&"
export * from "./TrainingCommentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports